import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Catalogue from './pages/Catalogue';
import Details from './pages/Details';
import Error404 from './pages/Error404';
import Home from './pages/home';
import VR from './pages/VR';


const RouteUrls = () => {
    return ( 
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />}/>
                <Route path="/Catalogue" element={<Catalogue />}/>
                <Route path="/Details" element={<Details />} />
                <Route path="/VR" element={<VR /> } />
                <Route path='*' element={<Error404 />}/>
            </Routes>
        </BrowserRouter>
     );
}
 
export default RouteUrls;